module.exports = __webpack_public_path__ + "static/media/nine_monkeys.8091664d.png";